import en from '../en/explore'

const cz: typeof en = {
  keywords: 'Klíčová slova',
  go_to_create: 'Přejít na výstavy',
  create_exhibition: 'Vytvořit výstavu',
  search_keyword: 'Vyhledat podle klíčových slov',
  themes: 'Témata',
  characters: 'Lidé a postavy',
  animals: 'Zvířata',
  plants: 'Rostliny',
  objects: 'Předměty',
  bible: 'Bible',
  heraldry: 'Heraldika',
  architecture: 'Architektura',
  locations: 'Místa',
  military: 'Vojenství',
}

export default cz
